<template>
  <div class="form-header" v-if="!hideHeader">
    <div class="layout-content">
      <div class="logo header-logo">
        <slot name="logo">
          <a href="https://www.infoq.cn">
            <img src="../../../assets/img/logo-new.png" alt="logo" />
          </a>
        </slot>
      </div>
      <template v-if="loginType">
        <div class="head-img" v-if="loginUser">
          <img :src="loginUser.avatar || defaultImg" :title="loginUser.nick" :alt="loginUser.nick">
          <div class="login-out" @click="loginOut">
            退出
          </div>
        </div>
        <div v-else class="login" @click="login"><span>登录</span> / <span>注册</span></div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      defaultImg: require('../../../assets/img/default-avatar.png')
    }
  },
  props: {
    headerInfo: {
      type: Object,
      default () {
        return {}
      }
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    loginType: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState(['isMobile', 'loginUser'])
  },
  created () {
  },
  methods: {
    login () {
      this.$emit('login', 'form')
    },
    loginOut () {
      this.$emit('loginOut')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/css/common';

.form-header {
  position: relative;
  display: flex;
  height: 69px;
  background: #fff;
  z-index: 10;

  & .layout-content {
    position: relative;
  }

  & .logo {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    // @extend %center;
    cursor: pointer;

    & img {
      display: block;
      height: 32px; width: auto;
    }
  }

  & .head-img {
    position: absolute; right: 0;
    padding: 15px 0;
    width: 40px;
    cursor: pointer;

    & img {
      display: block;
      width: 100%;
      border-radius: 50%;
    }

    &:hover {
      & .login-out {
        display: block;
      }
    }

    & .login-out {
      display: none;
      position: absolute;
      bottom: -40px; left: -20px;
      width: 80px;
      padding: 10px 20px;
      background: #fff;
      text-align: center;
      box-shadow: 0 2px 10px 0 rgba($color: #000000, $alpha: .1);
      &:hover {
        color: $blue;
      }
    }
  }

  & .login {
    position: absolute; right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 80px;
    cursor: pointer;

    & span:hover {
      color: $blue;
    }
  }
}
@media screen and (max-width: 768px) {
  .form-header {
    height: 45px;
    & .head-img {
      width: 30px;
      right: 10px;

      & .login-out {
        left: -50px;
      }
    }
    & .login {
      padding-right: 10px;
      width: auto;
      font-size: 13px;
    }
    & .logo {
      left: 50%;
      transform: translate(-50%, -50%);
      & img {
        height: 25px;
      }
    }
  }
}
</style>
